package fr.frux.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.FavoriteBorder
import androidx.compose.material.icons.outlined.Map
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material.icons.outlined.ShoppingBasket
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.app.resources.Res
import fr.frux.app.resources.nav_tab_explore
import fr.frux.app.resources.nav_tab_favorites
import fr.frux.app.resources.nav_tab_harvests
import fr.frux.app.resources.nav_tab_profile
import fr.frux.core.designsystem.components.FruxBottomNav
import fr.frux.core.designsystem.components.FruxNavItem
import fr.frux.navigation.Route.Favorites
import fr.frux.navigation.Route.Harvests
import fr.frux.navigation.Route.Map
import fr.frux.navigation.Route.Profile
import org.jetbrains.compose.resources.stringResource

/**
 * Destinations de premier niveau, dans l'ordre d'affichage. Source unique de la barre du bas et
 * du rail grand écran (spec 2026-09-10, §4) : un onglet s'ajoute ici et nulle part ailleurs.
 */
@Composable
fun fruxNavItems(): List<FruxNavItem<Route>> =
    listOf(
        FruxNavItem(Map, stringResource(Res.string.nav_tab_explore), Icons.Outlined.Map),
        FruxNavItem(Harvests, stringResource(Res.string.nav_tab_harvests), Icons.Outlined.ShoppingBasket),
        FruxNavItem(Favorites, stringResource(Res.string.nav_tab_favorites), Icons.Outlined.FavoriteBorder),
        FruxNavItem(Profile, stringResource(Res.string.nav_tab_profile), Icons.Outlined.Person),
    )

@Composable
fun BottomNavigation(
    currentRoute: Route,
    onNavigate: (Route) -> Unit,
    onAddTreeClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val navItems = fruxNavItems()
    FruxBottomNav(
        items = navItems,
        isSelected = { it.route == currentRoute },
        onSelect = { onNavigate(it.route) },
        onAddClick = onAddTreeClick,
        modifier = modifier,
    )
}

fun Route.shouldShowBottomNav(): Boolean =
    when (this) {
        is Map, is Harvests, is Favorites, is Profile -> true
        else -> false
    }
